let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("aHG2I"), load("bJvam"), load("arhgZ"), load("4GiCQ")]).then(() => parcelRequire('5LmZi'));